import React from 'react'

function Table({tableHead,tableBody}) {
    return (
        <table className="min-w-full bg-white">
            <thead className="bg-gray-50 text-center">
               {tableHead}
            </thead>
            <tbody className="divide-y divide-gray-200 text-center">
                {tableBody}
            </tbody>
        </table>
    )
}

export default Table